import { action } from '@ember/object';
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import eq from 'ember-truth-helpers/helpers/eq';

interface InputSelectSignature {
  // The arguments accepted by the component
  Args: {};
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class InputSelectComponent extends Component<InputSelectSignature> {
  <template>
    <div
      class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2 col-span-6"
    >
      <label
        for={{@name}}
        class="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5 sm:text-right"
      >{{@label}}</label>
      <div class="mt-2 sm:col-span-2 sm:mt-0">
        <select
          {{on "change" this.change}}
          name={{@name}}
          id={{@name}}
          value={{@value}}
          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
        >
          {{#each @options as |opt|}}
            <option
              value={{opt.value}}
              selected={{eq opt.value @value}}
            >{{opt.name}}</option>

          {{/each}}
        </select>
      </div>
    </div>
  </template>
  @action
  change() {
    if (this.args.onChange) {
      this.args.onChange(...arguments);
    }
  }
}
